import { addDays } from "@progress/kendo-date-math";
import { ReviewQuoteRequest } from "../types/quotes/review";
import { apiClient } from "./apiClient";

const endpoint = "quotes";

const getSummary = (dates: any) => {
  const params = getDateParams(dates);
  if (!params) return [];

  return apiClient(`${endpoint}/summary`).fetchWithParams(params);
};

const getDetails = (quoteId: number) => {
  const params = `?quoteId=${quoteId}`;
  return apiClient(`${endpoint}/details`).fetchWithParams(params);
};

const getStatusSummary = (dates: any) => {
  const params = getDateParams(dates);
  if (!params) return [];

  return apiClient(`${endpoint}/status`).fetchWithParams(params);
};

const getStatusDetails = (dates: any) => {
  const params = getDateParams(dates);
  if (!params) return [];

  return apiClient(`${endpoint}/statusDetails`).fetchWithParams(params);
};

const getHitRates = () => apiClient(`${endpoint}/hitRates`).fetch();

const getDateParams = (dates: { start: Date; end: Date }) => {
  if (!dates || !dates.start || !dates.end) return "";

  // Set start / end dates to midnight and convert to UTC
  dates.start.setHours(0, 0, 0, 0);
  const newEnd = addDays(dates.end, 1);
  newEnd.setHours(0, 0, 0, 0);

  const params = `?startDate=${dates.start.toISOString()}&endDate=${newEnd.toISOString()}`;
  return params;
};

export const submitQuote = (
  pricingId: number,
  quoteId: number,
  approve?: boolean
) => {
  const data = { pricingId, quoteId, approve };
  const result = apiClient(`${endpoint}/submit`).post(data);
  return result;
};

const reviewQuote = (data: ReviewQuoteRequest) => {
  const result = apiClient(`${endpoint}/review`).post(data);
  return result;
};

const deleteQuote = (quoteId: number) => {
  return apiClient(endpoint).delete(quoteId);
};

const copyQuote = (quoteId: number, companyId: number | null) => {
  const params = companyId ? `?quoteId=${quoteId}&companyId=${companyId}` : `?quoteId=${quoteId}`;
  return apiClient(`${endpoint}/copy`).fetchWithParams(params);
};

const getMarginsDetails = (quoteId: number, pricingId: number) =>
  apiClient(`${endpoint}/margins`).fetchWithParams(`?quoteId=${quoteId}&pricingId=${pricingId}`);

const getSlippage = (quoteId: number, pricingId: number) =>
  apiClient(`${endpoint}/slippage`).fetchWithParams(`?quoteId=${quoteId}&pricingId=${pricingId}`);

const renameQuote = (quoteId: number, name: string) => {
  const data = { quoteId, name };
  return apiClient(`${endpoint}/rename`).put(data);
};

export default {
  getSummary,
  getDetails,
  submitQuote,
  reviewQuote,
  deleteQuote,
  copyQuote,
  getStatusSummary,
  getStatusDetails,
  getHitRates,
  getMarginsDetails,
  getSlippage,
  renameQuote,
};
